import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { ArrowLinkButton } from "~/components/ArrowLinkButton";
import { ROUTES } from "~/content/Routes";
import { CITIES, CITY_COORDINATES, findCityByName } from "~/lib/cities";
import type { CityMarker } from "~/components/PolandMap";

const PolandMap = dynamic(() => import("~/components/PolandMap"), {
  ssr: false,
  loading: () => (
    <div className="flex min-h-[420px] items-center justify-center rounded-xl bg-gray-50 text-sm text-gray-400">
      Ładowanie mapy…
    </div>
  ),
});

const TOP_CITIES = [
  { slug: "warszawa",    name: "Warszawa",    description: "Mazowsze" },
  { slug: "krakow",     name: "Kraków",      description: "Małopolska" },
  { slug: "gdansk",     name: "Gdańsk",      description: "Pomorze" },
  { slug: "wroclaw",    name: "Wrocław",     description: "Dolny Śląsk" },
  { slug: "poznan",     name: "Poznań",      description: "Wielkopolska" },
  { slug: "lodz",       name: "Łódź",        description: "Łódź" },
  { slug: "katowice",   name: "Katowice",    description: "Śląsk" },
  { slug: "szczecin",   name: "Szczecin",    description: "Zachodniopomorskie" },
  { slug: "lublin",     name: "Lublin",      description: "Lubelskie" },
  { slug: "bydgoszcz",  name: "Bydgoszcz",  description: "Kujawsko-Pomorskie" },
  { slug: "rzeszow",    name: "Rzeszów",     description: "Podkarpacie" },
  { slug: "bialystok",  name: "Białystok",   description: "Podlaskie" },
  { slug: "olsztyn",    name: "Olsztyn",     description: "Warmia-Mazury" },
  { slug: "czestochowa",name: "Częstochowa", description: "Śląsk" },
];

export function HomeCitySection() {
  const router = useRouter();

  const allCityMarkers: CityMarker[] = CITIES.map((c) => {
    const coords = CITY_COORDINATES[c.slug];
    return { name: c.name, lat: coords.lat, lng: coords.lng };
  });

  const handleCityClick = (city: CityMarker) => {
    const found = findCityByName(city.name);
    if (found) router.push(`/${found.slug}/`);
  };

  return (
    <section className="bg-white py-12">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-start">
          {/* Mapa */}
          <div className="w-full flex-shrink-0 lg:w-[55%]">
            <PolandMap
              cities={allCityMarkers}
              center={[52.1, 19.4]}
              zoom={6}
              height="420px"
              highlightedCityName="Warszawa"
              onCityClick={handleCityClick}
            />
          </div>

          {/* Siatka miast */}
          <div className="flex-1">
            <h3 className="mb-3 text-sm font-semibold uppercase tracking-wide text-gray-500">
              Największe miasta
            </h3>
            <div className="grid grid-cols-2 gap-2">
              {TOP_CITIES.map((city) => (
                <ArrowLinkButton
                  key={city.slug}
                  href={`/${city.slug}/`}
                  label={city.name}
                />
              ))}
              <ArrowLinkButton
                href={ROUTES.CITIES}
                label="Wszystkie miasta"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
